import { ArrowRight } from "lucide-react";

const HERO_IMG =
    "https://images.unsplash.com/photo-1766561994067-dbd575e1cff2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

const stats = ["04 Asset Classes", "One Owner", "Leased to Legacy Transit Solutions"];

export default function Hero() {
    return (
        <section id="top" data-testid="hero-section" className="pt-32 pb-24 px-6">
            <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
                <div>
                    <p className="rise-in font-mono2 text-xs uppercase tracking-widest text-amber-500 mb-6">
                        Fleet Holding Company — Built for the Road
                    </p>
                    <h1 className="rise-in rise-delay-1 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-tight text-white mb-6">
                        Capitalizing Commercial Transportation &amp; Specialized Fleet Vehicles
                    </h1>
                    <p
                        data-testid="hero-subtitle"
                        className="rise-in rise-delay-2 text-base text-slate-300 leading-relaxed mb-8 max-w-xl"
                    >
                        Legacy GV Ventures is the holding company behind Legacy Transit Solutions.
                        We&rsquo;re acquiring medical courier vans, courier vehicles, rental RVs, and
                        pilot cars for oversized loads — every one of them leased to the operators
                        who run the road.
                    </p>
                    <div
                        data-testid="hero-stats-row"
                        className="rise-in rise-delay-3 flex flex-wrap gap-3 mb-10"
                    >
                        {stats.map((s) => (
                            <span
                                key={s}
                                className="font-mono2 text-xs uppercase tracking-wider text-slate-200 border border-white/15 bg-white/5 px-4 py-2 rounded-full"
                            >
                                {s}
                            </span>
                        ))}
                    </div>
                    <div className="rise-in rise-delay-4 flex flex-wrap gap-4">
                        <a
                            href="#enquiry"
                            data-testid="hero-cta-enquiry"
                            className="inline-flex items-center gap-2 bg-amber-500 text-black font-semibold px-7 py-3 rounded-full hover:bg-amber-400 transition-colors duration-200"
                        >
                            Send an Enquiry <ArrowRight size={16} />
                        </a>
                        <a
                            href="#assets"
                            data-testid="hero-cta-assets"
                            className="inline-flex items-center gap-2 border border-white/20 text-white font-semibold px-7 py-3 rounded-full hover:border-amber-500/60 hover:text-amber-400 transition-colors duration-200"
                        >
                            View Asset Classes
                        </a>
                    </div>
                </div>
                <div className="rise-in rise-delay-2 img-frame relative">
                    <div className="absolute -top-3 -left-3 w-24 h-24 border-t-2 border-l-2 border-amber-500" />
                    <img
                        src={HERO_IMG}
                        alt="Commercial fleet vehicles and highway logistics transport"
                        data-testid="hero-fleet-image"
                        className="w-full h-[420px] object-cover"
                    />
                    <div className="absolute -bottom-3 -right-3 w-24 h-24 border-b-2 border-r-2 border-amber-500" />
                </div>
            </div>
        </section>
    );
}
